import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import { Button } from '@pella/sash-framework';
import { Image } from '../../../';
import { isValidArray } from '../../../utilities/validations';

const EmployeeCard = ({ bio, className }) => (
	<div className={`employeeCard group relative ${className || ''}`}>
		{bio?.url && bio.url !== '/' && (
			<Link
				to={bio.url}
				className='z-1 -indent-full absolute left-0 top-0 block h-full w-full border border-neutral-100 group-focus-within:shadow-lg group-hover:shadow-lg'
			>
				{bio?.about?.heading}
			</Link>
		)}

		<div className='p-6 text-center'>
			{isValidArray(bio?.image) && (
				<Image
					data={bio.image[0]}
					aspectRatio={1}
					className='mb-3 h-[150px] w-[150px] rounded-full'
				/>
			)}

			{bio?.about?.heading && <p className='subtitle-1 m-0 font-bold text-black'>{bio.about.heading}</p>}

			{bio?.about?.job_title && <p className='text-body-2 mt-1.5 text-black'>{bio.about.job_title}</p>}

			{bio?.url && bio.url !== '/' && (
				<Button
					href={bio.url}
					component={Link}
					color='tertiary'
					className='z-2 relative mt-1.5'
				>
					{bio?.about?.read_bio || 'Read Bio'}
				</Button>
			)}
		</div>
	</div>
);

EmployeeCard.propTypes = {
	bio: PropTypes.object.isRequired,
	className: PropTypes.string,
};

export default EmployeeCard;
